var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "distribution-chart-page" },
    [
      _c(
        "el-card",
        { staticClass: "filter-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top", size: "small" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8, lg: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "货品名称" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              on: { change: _vm.selectGri },
                              model: {
                                value: _vm.form.tplId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "tplId", $$v)
                                },
                                expression: "form.tplId",
                              },
                            },
                            _vm._l(_vm.griList, function (item) {
                              return _c("el-option", {
                                key: item.tplId,
                                attrs: {
                                  label:
                                    item.griName + "(GRI:" + item.griCode + ")",
                                  value: item.tplId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8, lg: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "制成分类" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              on: { change: _vm.selectProcess },
                              model: {
                                value: _vm.form.category,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "category", $$v)
                                },
                                expression: "form.category",
                              },
                            },
                            _vm._l(_vm.processList, function (item) {
                              return _c("el-option", {
                                key: item.tplProcessId,
                                attrs: {
                                  label: item.processName,
                                  value: item.tplProcessId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8, lg: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "分析指标" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              on: { change: _vm.selectFactor },
                              model: {
                                value: _vm.form.factorId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "factorId", $$v)
                                },
                                expression: "form.factorId",
                              },
                            },
                            _vm._l(_vm.factorList, function (item) {
                              return _c("el-option", {
                                key: item.tplFactorId,
                                attrs: {
                                  label: item.factorName,
                                  value: item.tplFactorId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8, lg: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "参数" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: !_vm.paramList.length,
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.paramId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "paramId", $$v)
                                },
                                expression: "form.paramId",
                              },
                            },
                            _vm._l(_vm.paramList, function (item) {
                              return _c("el-option", {
                                key: item.tplParamId,
                                attrs: {
                                  label: item.paramName,
                                  value: item.tplParamId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8, lg: 4 } },
                    [
                      _c("el-form-item", { attrs: { label: "标准范围" } }, [
                        _c(
                          "div",
                          { staticClass: "range-inputs" },
                          [
                            _c("el-input", {
                              attrs: {
                                value: _vm.standardFrom,
                                disabled: "",
                                placeholder: "",
                              },
                            }),
                            _c("span", [_vm._v("-")]),
                            _c("el-input", {
                              attrs: {
                                value: _vm.standardTo,
                                disabled: "",
                                placeholder: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8, lg: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "采样点数 (n)" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            model: {
                              value: _vm.form.samplePoints,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "samplePoints", $$v)
                              },
                              expression: "form.samplePoints",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "vendor-row", attrs: { gutter: 16 } },
                [
                  _c("el-col", { attrs: { xs: 24, lg: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "vendor-panel base-panel" },
                      [
                        _c("div", { staticClass: "panel-title" }, [
                          _c("i", { staticClass: "el-icon-flag" }),
                          _vm._v(" 基准分析对象"),
                        ]),
                        _c(
                          "el-row",
                          { attrs: { gutter: 16 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { xs: 24, sm: 10 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "供应商选择" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        model: {
                                          value: _vm.form.basePlantCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "basePlantCode",
                                              $$v
                                            )
                                          },
                                          expression: "form.basePlantCode",
                                        },
                                      },
                                      _vm._l(_vm.supplierList, function (item) {
                                        return _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.name,
                                            value: item.code,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { xs: 24, sm: 14 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "生产批次/时间" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "date-range" },
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "date",
                                            "value-format": "yyyy-MM-dd",
                                            placeholder: "开始日期",
                                          },
                                          model: {
                                            value: _vm.form.baseDateFrom,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "baseDateFrom",
                                                $$v
                                              )
                                            },
                                            expression: "form.baseDateFrom",
                                          },
                                        }),
                                        _c("span", [_vm._v("至")]),
                                        _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "date",
                                            "value-format": "yyyy-MM-dd",
                                            placeholder: "结束日期",
                                          },
                                          model: {
                                            value: _vm.form.baseDateTo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "baseDateTo",
                                                $$v
                                              )
                                            },
                                            expression: "form.baseDateTo",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { xs: 24, lg: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "vendor-panel compare-panel" },
                      [
                        _c(
                          "div",
                          { staticClass: "panel-title" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.form.contrast,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "contrast", $$v)
                                  },
                                  expression: "form.contrast",
                                },
                              },
                              [_vm._v("开启供应商对比")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          {
                            class: { "disabled-content": !_vm.form.contrast },
                            attrs: { gutter: 16 },
                          },
                          [
                            _c(
                              "el-col",
                              { attrs: { xs: 24, sm: 10 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "对比供应商" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: { disabled: !_vm.form.contrast },
                                        model: {
                                          value: _vm.form.contrastPlantCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "contrastPlantCode",
                                              $$v
                                            )
                                          },
                                          expression: "form.contrastPlantCode",
                                        },
                                      },
                                      _vm._l(_vm.supplierList, function (item) {
                                        return _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.name,
                                            value: item.code,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { xs: 24, sm: 14 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "生产批次/时间" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "date-range" },
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "date",
                                            "value-format": "yyyy-MM-dd",
                                            placeholder: "开始日期",
                                            disabled: !_vm.form.contrast,
                                          },
                                          model: {
                                            value: _vm.form.contrastDateFrom,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "contrastDateFrom",
                                                $$v
                                              )
                                            },
                                            expression: "form.contrastDateFrom",
                                          },
                                        }),
                                        _c("span", [_vm._v("至")]),
                                        _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "date",
                                            "value-format": "yyyy-MM-dd",
                                            placeholder: "结束日期",
                                            disabled: !_vm.form.contrast,
                                          },
                                          model: {
                                            value: _vm.form.contrastDateTo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "contrastDateTo",
                                                $$v
                                              )
                                            },
                                            expression: "form.contrastDateTo",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "action-row" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.generateAnalysis },
                    },
                    [_vm._v("分布图分析")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled: !_vm.analysis,
                      },
                      on: { click: _vm.exportData },
                    },
                    [_vm._v("导出")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.resetForm },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", { staticClass: "chart-card", attrs: { shadow: "never" } }, [
        _c(
          "div",
          {
            staticClass: "card-header",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.analysis ? _vm.analysis.chartTitle : "产品数据正态分布图"
                )
              ),
            ]),
          ]
        ),
        _vm.analysis
          ? _c(
              "div",
              {
                staticClass: "insight-summary",
                class: { "compare-mode": _vm.analysis.compare },
              },
              [
                _c("div", { staticClass: "insight-stats" }, [
                  _c(
                    "div",
                    { staticClass: "insight-stat" },
                    [
                      _c(
                        "el-tag",
                        { attrs: { size: "mini", type: "primary" } },
                        [_vm._v("基准")]
                      ),
                      _c("span", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.analysis.base.plantName) + "："),
                        ]),
                        _vm._v(
                          "n=" +
                            _vm._s(_vm.analysis.base.n) +
                            "，均值μ=" +
                            _vm._s(_vm.analysis.base.avg) +
                            _vm._s(_vm.analysis.unit) +
                            "，标准差σ=" +
                            _vm._s(_vm.analysis.base.stdev) +
                            _vm._s(_vm.analysis.unit) +
                            "，范围" +
                            _vm._s(_vm.analysis.base.standardRange || "-")
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm.analysis.compare
                    ? _c(
                        "div",
                        { staticClass: "insight-stat" },
                        [
                          _c(
                            "el-tag",
                            { attrs: { size: "mini", type: "danger" } },
                            [_vm._v("对比")]
                          ),
                          _c("span", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.analysis.compare.plantName) + "："
                              ),
                            ]),
                            _vm._v(
                              "n=" +
                                _vm._s(_vm.analysis.compare.n) +
                                "，均值μ=" +
                                _vm._s(_vm.analysis.compare.avg) +
                                _vm._s(_vm.analysis.unit) +
                                "，标准差σ=" +
                                _vm._s(_vm.analysis.compare.stdev) +
                                _vm._s(_vm.analysis.unit) +
                                "，范围" +
                                _vm._s(
                                  _vm.analysis.compare.standardRange || "-"
                                )
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            )
          : _vm._e(),
        _c("div", { ref: "chart", staticClass: "chart-container" }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }